module.exports = __webpack_public_path__ + "adam_seidman.jpg?ea4ec403ceae7e226576cee4fa457e58";